// extracted by mini-css-extract-plugin
module.exports = {"rowSeparator":"ContactItem_rowSeparator__2A3Ev","area":"ContactItem_area__zCnhh","value":"ContactItem_value__2VST3","contactTitle":"ContactItem_contactTitle__HpYuF"};